import { render, staticRenderFns } from "./medkitlogProofStatus.vue?vue&type=template&id=5a0c452a&scoped=true"
import script from "./medkitlogProofStatus.vue?vue&type=script&lang=js"
export * from "./medkitlogProofStatus.vue?vue&type=script&lang=js"
import style0 from "./medkitlogProofStatus.vue?vue&type=style&index=0&id=5a0c452a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0c452a",
  null
  
)

export default component.exports